import React, { useEffect, useRef, useState } from "react";
import IndustryCard from "../IndustryCard";
import LabelSwitching from "@/components/business/LabelSwitching/ectype";
import Collapse from "@/components/UI/Collapse/ectype";
import useData from "../../useData";
import GridContainer from "@/components/UI/GridContainer";
import SortBox from "../SortBox";
import "./index.less";
import { Spin } from "@arco-design/web-react";

function System() {
  const {
    tagList,
    tagLoading,
    hotspotVideoList,
    hotspotVideoLoading,
    hotspotVideoSearch,
    setHotspotVideoSearch,
    setHotspotVideoList,
    isVideos,
  } = useData();
  const observableElementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hotspotVideoLoading && isVideos) {
        setHotspotVideoSearch({
          ...hotspotVideoSearch,
          page: hotspotVideoSearch.page + 1,
        });
      }
    });
    const element = observableElementRef.current;
    if (element) {
      observer.observe(element);
    }
    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [hotspotVideoLoading, observableElementRef.current, isVideos]);

  return (
    <div className="system-root">
      <div className="tag-root">
        <div className="tag">
          <Collapse hiddenHeight={55}>
            <LabelSwitching
              tagList={tagList}
              isLoading={tagLoading}
              renderProps={(opt) => {
                //
              }}
              checkRenderProps={(arr: any) => {
                if (!arr.length) {
                  return;
                }
                hotspotVideoSearch.tags =
                  arr[0].content.map((item) => ({
                    value: Number(item.value),
                    children: item.children.length
                      ? item.children.map((v) => ({
                          value: Number(v.value),
                        }))
                      : undefined,
                  })) || [];
                hotspotVideoSearch.sub_type = arr[1].content[0]?.value;
                hotspotVideoSearch.date_window = arr[2].content[0]?.value;
                setHotspotVideoList([]);
                setHotspotVideoSearch({ ...hotspotVideoSearch });
              }}
            />
          </Collapse>
        </div>
      </div>
      {/* <SortBox
            renderProps={(type) => {
              console.log("====================================");
              console.log(type);
              console.log("====================================");
            }}
          /> */}
      <Spin loading={hotspotVideoLoading}>
        <div className="industry-card-box">
          <GridContainer dataLength={hotspotVideoList.length} boxGap={33}>
            {hotspotVideoList.map((v, i) => (
              <div
                key={i}
                ref={(ref) => {
                  if (hotspotVideoList.length - 1 == i) {
                    observableElementRef.current = ref;
                  }
                }}>
                <GridContainer.Item>
                  <IndustryCard item={v} />
                </GridContainer.Item>
              </div>
            ))}
          </GridContainer>
        </div>
      </Spin>
    </div>
  );
}

export default System;
